import { useClientTranslation } from '@/lib/core/i18n';
import { cn } from '@/lib/core';

export interface SoldOutTagProps {
  className?: string;
}

/**
 * Pill-shaped "Sold Out" tag. Positioned absolutely by its parent (ProductListingCard).
 */
export function SoldOutTag({ className }: SoldOutTagProps) {
  const t = useClientTranslation();

  return (
    <span
      className={cn(
        'bg-jncquoi-neutral-1000 inline-flex items-center justify-center rounded-[2px] px-2 py-1',
        'font-pp-neue-montreal text-jncquoi-neutral-00 text-[10px] leading-none font-semibold tracking-[0.5px] uppercase',
        className
      )}
    >
      {t('App.Shop.SoldOut')}
    </span>
  );
}
